import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row, Nav, NavItem, NavLink, TabContent, TabPane, Table, Badge } from 'reactstrap';
import classnames from 'classnames';

const DetailsSection = ({ detail }) => {
    // Sekmeler için state
    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
const isAdmin = authUser?.HESAP_TURU === 'Admin'; // 3: Admin
const userId = authUser?.ID; // Kullanıcının kendi teklifini bulmak için eklendi

const durumText = d => d === 1 ? "Kabul Edildi" : d === 2 ? "Reddedildi" : "Bekliyor";
const durumColor = d => d === 1 ? "success" : d === 2 ? "danger" : "warning";

// Teklif durumunu güncelleyen fonksiyon
const updateOfferStatus = async (offerId, newDurum) => {
    const label = durumText(newDurum);
    if (!window.confirm(`Bu teklifi "${label}" olarak işaretlemek istediğinize emin misiniz?`)) return;

    try {
        const payload = { DURUM: newDurum };

        const response = await fetch(`https://harmanappapi.stechomeyazilim.info/ILAN_TEKLIFLERI(${offerId})`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (response.ok) {
            alert(`Teklif başarıyla ${label} olarak güncellendi!`);
            window.location.reload();
        } else {
            alert("Teklif güncellenirken bir hata oluştu.");
        }
    } catch (error) {
        console.error("Güncelleme hatası:", error);
        alert("Bağlantı hatası oluştu.");
    }
};


    return (
        <React.Fragment>
            <Col xl={8}>
                {/* 1. ROTA KARTI */}
                <Card className="border shadow-none mb-4 rounded-3">
                    <CardBody>
                        <div className="bg-dark text-white px-3 py-1 rounded-pill d-inline-block mb-4 fw-medium">
                            Rota {detail.distance} - {detail.duration}
                        </div>
                        
                        <Row>
                            <Col md={6} className="border-end border-light">
                                <div className="d-flex mb-3">
                                    <div className="me-2 fs-5">{detail.start.countryFlag}</div>
                                    <div>
                                        <h5 className="mb-1 fw-bold">{detail.start.city}</h5>
                                        <p className="text-muted mb-3">{detail.start.date}</p>
                                        
                                        <h6 className="text-muted text-uppercase fs-12 mb-1">Kalkış Adresi</h6>
                                        <p className="mb-2 text-dark" style={{ whiteSpace: "pre-wrap" }}>
                                            {detail.start.address}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6} className="ps-md-4">
                                <div className="d-flex mb-3">
                                    <div className="me-2 fs-5">{detail.end.countryFlag}</div>
                                    <div>
                                        <h5 className="mb-1 fw-bold">{detail.end.city}</h5>
                                        <p className="text-muted mb-3">{detail.end.date}</p>
                                        
                                        <h6 className="text-muted text-uppercase fs-12 mb-1">Varış Adresi</h6>
                                        <p className="mb-2 text-dark" style={{ whiteSpace: "pre-wrap" }}>
                                            {detail.end.address}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* 2. ARAÇ KARTI (Güncellendi) */}
                <Card className="border shadow-none mb-4 rounded-3">
                    <CardBody>
                        <div className="bg-dark text-white px-3 py-1 rounded-pill d-inline-block mb-4 fw-medium">
                            Araç Bilgileri
                        </div>
                        
                        <Row>
                            <Col md={7} className="border-end border-light">
                                <h6 className="d-flex align-items-center mb-4 text-dark fw-bold">
                                    <i className="mdi mdi-car me-2 fs-4 text-primary"></i> Araç Detayı
                                </h6>
                                <Row className="gy-3">
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">MARKA</p>
                                        <h6 className="fw-bold">{detail.vehicle.brand}</h6>
                                    </Col>
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">MODEL</p>
                                        <h6 className="fw-bold">{detail.vehicle.model}</h6>
                                    </Col>
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">KASA TİPİ</p>
                                        <h6 className="fw-bold">{detail.vehicle.bodyType}</h6>
                                    </Col>
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">PLAKA</p>
                                        <h6 className="fw-bold text-primary">{detail.vehicle.plate}</h6>
                                    </Col>
                                    <Col xs={8}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">ŞASE NO</p>
                                        <h6 className="fw-bold">{detail.vehicle.chassis}</h6>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={5} className="ps-md-4">
                                <h6 className="d-flex align-items-center mb-4 text-dark fw-bold">
                                    <i className="mdi mdi-gas-station me-2 fs-4 text-primary"></i> Operasyon & Yakıt
                                </h6>
                                <Row>
                                    <Col xs={12} className="mb-3">
                                        <p className="text-muted text-uppercase fs-12 mb-1">YAKIT TÜRÜ & DURUMU</p>
                                        <h6 className="fw-bold">{detail.vehicle.engine} - <span className="text-info">{detail.fuelStatus}</span></h6>
                                    </Col>
                                    <Col xs={12}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">MÜŞTERİ NOTLARI</p>
                                        <p className="mb-0 fs-13 text-danger fw-medium">{detail.customerNotes}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* 3. İLİŞKİLİ VERİLER (SEKMELER) */}
                <Card className="border shadow-none mb-4 rounded-3">
                    <CardBody className="pb-0">
                        <Nav tabs className="nav-tabs-custom">
                            <NavItem>
                                <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === '1' })} onClick={() => toggle('1')}>
                                    Görev Tanımı
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === '2' })} onClick={() => toggle('2')}>
                                    Teklifler <Badge color="danger" pill className="ms-1">{detail.offers.length}</Badge>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === '3' })} onClick={() => toggle('3')}>
                                    Masraflar
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </CardBody>

                    <CardBody>
                        <TabContent activeTab={activeTab}>
                            
                            {/* SEKME 1: GÖREV TANIMI (Eski 3. Kart) */}
                            <TabPane tabId="1">
                                <Row className="gy-4">
                                    <Col md={6}>
                                        <h6 className="d-flex align-items-center mb-3 fw-bold">
                                            <i className="mdi mdi-cog-outline me-2 text-primary fs-5"></i> Tamamlayıcı hizmetler
                                        </h6>
                                        <ul className="list-unstyled mb-0">
                                            {detail.services.map((service, index) => (
                                                <li key={index} className="mb-2 d-flex align-items-start">
                                                    <i className="mdi mdi-check text-success me-2 mt-1"></i> {service}
                                                </li>
                                            ))}
                                        </ul>
                                    </Col>
                                    <Col md={6}>
                                        <h6 className="d-flex align-items-center mb-3 fw-bold">
                                            <i className="mdi mdi-clipboard-text-outline me-2 text-primary fs-5"></i> Taşıma prosedürü
                                        </h6>
                                        <p className="mb-0"><strong>Yön:</strong> {detail.direction}</p>
                                    </Col>
                                </Row>
                            </TabPane>

                            {/* SEKME 2: TEKLİFLER (ILAN_TEKLIFLERI) */}
<TabPane tabId="2">
    {detail.offers.length > 0 ? (
        <div className="table-responsive">
            <Table className="table-sm table-nowrap mb-0 align-middle">
                <thead className="table-light">
                    <tr>
                        <th>Teklif No</th>
                        <th>Sürücü</th> {/* Doğru yere eklendi */}
                        <th>Fiyat</th>
                        <th>Tarih</th>
                        <th>Durum</th>
                        {isAdmin && <th className="text-end">Eylemler</th>}
                    </tr>
                </thead>
                <tbody>
                    {detail.offers.map((offer, i) => {
                        const isMyOffer = offer.KULLANICI_ID === userId;

                        return (
                            <tr key={i} className={isMyOffer ? "table-info" : ""}>
                                <td>
                                    #{offer.ID}
                                    {isMyOffer && (
                                        <Badge color="info" className="ms-2">
                                            <i className="mdi mdi-star me-1"></i>Senin Teklifin
                                        </Badge>
                                    )}
                                </td>
                                <td>
                                    <span className="fw-medium text-dark d-block">
                                        {offer.KULLANICILAR ? offer.KULLANICILAR.AD_SOYAD : "Bilinmiyor"}
                                    </span>
                                    <span className="text-muted" style={{fontSize: "11px"}}>
                                        ID: #{offer.KULLANICI_ID}
                                    </span>
                                </td>
                                <td className="fw-bold text-primary">{offer.TEKLIF_TUTARI} ₺</td>
                                <td>{offer.TEKLIF_TARIHI ? new Date(offer.TEKLIF_TARIHI).toLocaleString('tr-TR') : "-"}</td>
                                <td>
                                    <Badge color={durumColor(offer.DURUM)}>{durumText(offer.DURUM)}</Badge>
                                </td>

                                {isAdmin && (
                                    <td className="text-end">
                                        <div className="d-flex justify-content-end gap-2">
                                            <button
                                                className="btn btn-success btn-sm"
                                                disabled={offer.DURUM === 1}
                                                onClick={() => updateOfferStatus(offer.ID, 1)}
                                            >
                                                <i className="mdi mdi-check me-1"></i> Kabul Et
                                            </button>

                                            <button
                                                className="btn btn-danger btn-sm outline"
                                                disabled={offer.DURUM === 2}
                                                onClick={() => updateOfferStatus(offer.ID, 2)}
                                            >
                                                <i className="mdi mdi-close me-1"></i> Reddet
                                            </button>
                                        </div>
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    ) : (
        <p className="text-muted fst-italic mb-0">Henüz bu ilana yapılmış bir teklif bulunmuyor.</p>
    )}
</TabPane>

                            {/* SEKME 3: MASRAFLAR (Advert_Expenses) */}
                            <TabPane tabId="3">
                                {detail.expenses.length > 0 ? (
                                    <div className="table-responsive">
                                        <Table className="table-sm table-nowrap mb-0 align-middle">
                                          <thead className="table-light">
                                                <tr>
                                                    <th>Yakıt</th>
                                                    <th>Geçiş (Toll)</th>
                                                    <th>Toplu Taşıma</th>
                                                    <th>Taksi</th>
                                                    <th>Toplam</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {detail.expenses.map((exp, i) => (
                                                    <tr key={i}>
                                                        <td>{exp.Fuel_Expense || 0} TL</td>
                                                        <td>{exp.Toll_Fee || 0} TL</td>
                                                        <td>{exp.Public_Transport || 0} TL</td>
                                                        <td>{exp.Taxi_Expense || 0} TL</td>
                                                        <td className="fw-bold text-danger">{exp.Total_Expense || 0} TL</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                ) : (
                                    <p className="text-muted fst-italic mb-0">Bu görev için henüz masraf kaydı girilmemiş.</p>
                                )}
                            </TabPane>

                        </TabContent>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
}

export default DetailsSection;